import React from "react";

export function ResourcesOutdatedText() {
    return (
        <div>
            <div>Для продолжения работы в редакторе необходимо выполнить обновление страницы</div>
        </div>
    );
}
